import React from "react";
import clsx from "clsx";

import { LineDivider } from "./lineDivider";

import styles from "./layout.module.scss";

type ViewSectionProps = {
	className?: string;
	style?: React.CSSProperties;
	title?: string;
	children: any;
	isLineDivider?: boolean;
};

export const ViewSection = ({
	children,
	title,
	className,
	style,
	isLineDivider = true,
}: ViewSectionProps) => {
	return (
		<div
			className={clsx(styles.viewSection, className)}
			style={{ ...style }}
		>
			{title && <h6 className={`${styles.viewSectionTitle}`}>{title}</h6>}
			{children}
			{isLineDivider && (
				<LineDivider className={`${styles.lineDividerHolder}`} />
			)}
		</div>
	);
};
